<template>
  <div>
    <!-- este vendria a ser el componente de dialogo pero solo si se pone el boolean de Deletedialog el cual se pondria como propiedad al momento de usar el comundialogcomp
    este cuanta con un ancho predeterminado para todos los casos y en efecto para cerrar el modal en ambos casos debes enviarlos por un @close-modal para que sea mas corto
    pero en el caso de eliminar  si puedes enviar los actions como prpiedades @cancel-item y @delete-item sin necesidad de abrir un v-model actions -->
    <template v-if="Confirmdialog">
      <v-dialog persistent v-model="showdialog" max-width="500px" class="modal">
        <v-card>
          <v-card-title class="py-3 pr-2 success">
            <span class="white--text">{{ titleWindow }} </span>
            <v-spacer />
            <v-btn icon color="white" @click="$emit('close-modal')">
              <v-icon>
                fas fa-times-circle
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-4 text-center">
            <slot name="body">

            </slot>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="$emit('confirm-item')" color="primary" text>
              SÍ
            </v-btn>
            <v-btn @click="$emit('cancel-item')" color="red" text>
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <template v-else-if="Deletedialog">
      <v-dialog v-model="showdialog" persistent max-width="340" class="modal">
        <v-card>
          <v-card-title class="py-3 pr-2 error">
            <span class="white--text">{{ titleWindow }}</span>
            <v-spacer />
            <v-btn icon color="white" @click="$emit('close-modal')">
              <v-icon>fas fa-times-circle </v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-4  text-center">
            <h4>
              <slot name="body"> </slot>
            </h4>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="$emit('delete-item')" color="primary" text :loading="loading" :disabled="loading">
              <!-- <v-icon small> fas fa-trash-alt</v-icon> -->
              <!-- <v-progress-circular v-if="loading" indeterminate :size="34" class="ml-3"></v-progress-circular> -->
              SÍ
            </v-btn>
            <v-btn @click="$emit('cancel-item')" text color="red">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <template v-else>
      <v-dialog scrollable v-model="showdialog" persistent class="modal" :max-width="maxWidth" :fullscreen="fullscreen"
        :transition="fullscreen ? 'dialog-bottom-transition' : 'dialog-transition'">
        <v-card>
          <v-card-title class="primary white--text">
            <slot name="title">
              {{ title }}
            </slot>

            <v-spacer></v-spacer>
            <v-btn x-small fab class="btn_style3" @click="$emit('close-modal')">
              <v-icon small>fa-times </v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text :class="classCardText">
            <slot name="body"> </slot>
          </v-card-text>

          <v-card-actions>
            <slot name="actions"> </slot>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>






    <!-- en el caso del modal normal aparte de que puede seleccionar si sera fullscreen y dalle otras ropiedaddes como pasarle un titulo en este caso si es oblicatiorio abrir un v-model body y un v-model
    actions -->

  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
      required: false,
    },
    // titulo que se ve en la barra alta del modal
    titleWindow: {
      type: String,
      default: "",
      required: false
    },

    // closeModal: Function,
    Deletedialog: Boolean,
    Confirmdialog: Boolean,
    fullscreen: Boolean,
    maxWidth: {
      type: String,
      default: "0",
    },
    value: {
      type: Boolean,

      required: true,
    },
    evento: String,
    classCardText: {
      type: String,
      default: "pt-6",
    },

    loading: {
      type: Boolean,
      default: false,
    },
    // dialogDelete: Boolean,
    // normalDialog: Boolean,
  },

  computed: {
    showdialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  // watch: {
  //   showDialog: {
  //     inmediate: true,
  //     handler(newValue) {
  //       this.dialog = newValue;
  //     },
  //   },
  // },

  // methods: {
  //   closeClick() {
  //     this.$emit("click");
  //     this.dialog = false;
  //   },
  // },
};
</script>
<style scoped></style>

